import { useEffect } from "react";
import Lenis from "lenis";
import { setLenis, scrollToId } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { StatsBand } from "@/components/StatsBand";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { OneTeam } from "@/components/OneTeam";
import { Awards } from "@/components/Awards";
import { WhyAJ } from "@/components/WhyAJ";
import { Process } from "@/components/Process";
import { Testimonials } from "@/components/Testimonials";
import { Enquiry } from "@/components/Enquiry";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

export default function Home() {
  useEffect(() => {
    const target = window.location.hash || null;
    if (target) {
      const t = setTimeout(() => scrollToId(target), 900);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-ink text-cream">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <StatsBand />
        <About />
        <Services />
        <OneTeam />
        <Awards />
        <WhyAJ />
        <Process />
        <Testimonials />
        <Enquiry />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
